import inquiryapply from '@/view/inquiry-apply';

const inquiry = {
    install:function (Vue) {
        Vue.component('inquiry',inquiryapply)
    }
}
export default inquiry;